import EventEmitter from "base/EventEmitter";
import $ from "jquery";

class Sidebar extends EventEmitter {
    constructor() {
        super();

        this.isOpen = false;
        this.built = false;
        Sidebar.instances.push(this);

        this.$content = $("<div>");
    }

    static get instances() {
        if ('undefined' === typeof this._instances) this._instances = [];

        return this._instances;
    }

    static set instances(val) {
        this._instances = val;
    }

    static closeAllExcept(val) {
        $.each(Sidebar.instances, (_, _val) => {
            if (_val !== val) _val.close();
        })
    }

    static closeAll() {
        this.closeAllExcept(null);
    }

    on() {
        if (arguments.length === 2) return super.on.apply(this, arguments);

        this.buildElement();
        this.$element.on.apply(this.$element, arguments);

        return this;
    }

    off() {
        if (arguments.length === 2) return super.off.apply(this, arguments);

        this.buildElement();
        this.$element.off.apply(this.$element, arguments);

        return this;
    }

    toggle() {
        if (this.isOpen) {
            this.emit("toggle", {open: false});
            this.close();
        } else {
            this.emit("toggle", {open: true});
            this.open();
        }
    }

    setContent($content) {
        this.$content = $content;
        this.update();
        return this;
    }

    update() {
        if (!this.isOpen) return;
        this.buildElement();

        this.$element.find(".js-content").html(this.$content);
    }

    open() {
        if (this.isOpen) return;
        this.isOpen = true;
        this.update();

        this.$element.addClass("admin-sidebar--open");
        Sidebar.closeAllExcept(this);

        this.emit('open');
        $("html").addClass("has-sidebar")
    }

    close() {
        if (!this.isOpen) return;
        this.isOpen = false;

        this.$element.removeClass("admin-sidebar--open");
        this.emit('close');
        $("html").removeClass("has-sidebar")
    }

    buildElement() {
        if (this.built) return;
        this.built = true;

        this.$element = $("<div>").addClass("admin-sidebar");
        this.$element.append($("<div>").addClass("admin-sidebar__content js-content"));
        $("body").append(this.$element);

        //noinspection SillyAssignmentJS Forces a reflow
        this.$element[0].innerHeight = this.$element[0].innerHeight;
    }

    destroy() {
        super.destroy();
        this.close();
        Sidebar.instances = Sidebar.instances.filter((val) => val !== this);
        this.$element.remove();
        this.emit("destroy");
        this.built = false;
    }

}

export default Sidebar;
